export interface BrowserCapabilities {
  indexedDb: boolean;
  serviceWorker: boolean;
  webCrypto: boolean;
  randomUuid: boolean;
  storageManager: boolean;
  installPrompt: boolean;
  standalone: boolean;
  blocking: string[];
}

export function detectCapabilities(): BrowserCapabilities {
  const indexedDb = "indexedDB" in globalThis;
  const serviceWorker = "serviceWorker" in navigator;
  const webCrypto = Boolean(
    globalThis.crypto && "subtle" in globalThis.crypto && "getRandomValues" in globalThis.crypto,
  );
  const randomUuid = Boolean(globalThis.crypto && "randomUUID" in globalThis.crypto);
  const manager = navigator.storage as Partial<StorageManager> | undefined;
  const storageManager = Boolean(
    manager && typeof manager.estimate === "function" && typeof manager.persist === "function",
  );
  const standalone =
    globalThis.matchMedia?.("(display-mode: standalone)").matches ||
    ("standalone" in navigator &&
      Boolean((navigator as Navigator & { standalone?: boolean }).standalone));
  const blocking = [
    ...(!indexedDb ? ["IndexedDB"] : []),
    ...(!webCrypto ? ["Web Crypto"] : []),
    ...(!randomUuid ? ["identificatori sicuri"] : []),
  ];
  return {
    indexedDb,
    serviceWorker,
    webCrypto,
    randomUuid,
    storageManager,
    installPrompt: "BeforeInstallPromptEvent" in globalThis,
    standalone,
    blocking,
  };
}

export async function requestPersistentStorage(): Promise<boolean | undefined> {
  if (!navigator.storage?.persist) return undefined;
  if (await navigator.storage.persisted()) return true;
  return navigator.storage.persist();
}

export async function storageDiagnostics() {
  const estimate = await navigator.storage?.estimate?.();
  return {
    persisted: (await navigator.storage?.persisted?.()) ?? false,
    usage: estimate?.usage ?? 0,
    quota: estimate?.quota ?? 0,
  };
}
